
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { l as labelsMixin } from './labels-mixin.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import 'element-ui/lib/radio';
import PendoRadio from './pendo-radio.js';
import 'element-ui/lib/radio-button';
import PendoRadioButton from './pendo-radio-button.js';
import RadioGroup from 'element-ui/lib/radio-group';

var script = {
  name: 'PendoRadioGroup',
  components: {
    ElRadioGroup: RadioGroup,
    PendoRadio,
    PendoRadioButton
  },
  mixins: [labelsMixin],
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    button: {
      type: Boolean,
      default: false
    },
    displayClass: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: direction => ['vertical', 'horizontal'].includes(direction)
    },
    options: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
        this.$emit('onChange', val);
        this.$emit('change', val);
      }

    },

    radioGroupClass() {
      return ['pendo-radio-group', this.displayClass, {
        'is-button-group': this.button,
        'is-vertical': this.direction === 'vertical' && !this.button,
        'is-horizontal': this.direction === 'horizontal' || this.button
      }];
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-radio-group",
    class: {
      'pendo-radio-group--inline-label': !!_vm.inlineLabel
    }
  }, [!!_vm.topLabel ? _c('div', {
    staticClass: "pendo-radio-group__label pendo-radio-group__label--top"
  }, [_vm._v("\n        " + _vm._s(_vm.topLabel) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('el-radio-group', {
    class: _vm.radioGroupClass,
    attrs: {
      "size": _vm.size,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }, [_vm._t("default", _vm._l(_vm.options, function (option, index) {
    return _c(_vm.button ? 'pendo-radio-button' : 'pendo-radio', _vm._b({
      key: "pendo-radio-group__item-" + index,
      tag: "component",
      attrs: {
        "selected": option.value === _vm.model
      }
    }, 'component', option, false));
  }))], 2), _vm._v(" "), !!_vm.bottomLabel ? _c('div', {
    staticClass: "pendo-radio-group__label pendo-radio-group__label--bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.bottomLabel) + "\n    ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-radio-group.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoRadioGroup = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoRadioGroup;
